import { FilterResolver } from "./FilterResolver";
import * as yup from "yup";

export const FilterGroupResolver = yup.object().shape({
  advancedLogic: yup.string().when("useAdvancedLogic", {
    is: true,
    then: yup
      .string()
      .matches(/^[0-9\sAND\sOR\s()]*$/, "Only numbers, ANDs, ORs, and (), are allowed")
      .required("Please fill out the advanced logic filter"),
  }),
  filters: yup.array().of(FilterResolver),
});
